import { buildDateFrom, buildDateTo, FieldType, FieldValue, FilterField, Filters, O, TimePeriod, timePeriodOptions } from "../../../../../features/ui"
import { useEffect, useState } from "react"
import { Driver, Roadmap } from "../../../state/types"
import { useDriverHooks } from "../../../hooks/driverHooks"

type Props = {
    drivers: Driver[]
    roadmaps: Roadmap[]
    onSearchStart: () => void
    onSearchDone: (driverList: Driver[], roadmapList: Roadmap[]) => void
}

const FiltersKey = 'driver'

export const DriverFilters = (props: Props) => {
    const { drivers, roadmaps, onSearchStart, onSearchDone } = props

    const [searchText, setSearchText] = useState<string>()
    const [period, setPeriod] = useState<string>(TimePeriod.LAST_7_DAYS)
    const [dateFrom, setDateFrom] = useState<Date>(buildDateFrom(7))
    const [dateTo, setDateTo] = useState<Date>(buildDateTo())

    const { searchDrivers } = useDriverHooks()

    useEffect(() => search(searchText, dateFrom, dateTo), [drivers])

    const search = (
        searchTextParam?: string,
        dateFromParam?: Date,
        dateToParam?: Date
    ) => {
        onSearchStart()
        let roadmapList = roadmaps.filter(roadmap => !dateFromParam || new Date(roadmap.date) >= dateFromParam)
        roadmapList = roadmapList.filter(roadmap => !dateToParam || new Date(roadmap.date) <= dateToParam)
        searchDrivers(drivers, searchTextParam).then(searchedList => {
            setTimeout(() => onSearchDone(searchedList, roadmapList), 100)
        })
    }

    const handleSearch = (value?: FieldValue) => {
        const newSearchText = value as O<string>
        setSearchText(newSearchText)
        search(newSearchText, dateFrom, dateTo)
    }

    const onChangePeriod = (value?: FieldValue) => {
        const newPeriod = value as O<string>
        if (newPeriod) {
            setPeriod(newPeriod)
            if (newPeriod !== TimePeriod.MANUAL) {
                let newDateFrom = dateFrom
                if (newPeriod === TimePeriod.TODAY) {
                    newDateFrom = buildDateFrom(0)
                } else if (value === TimePeriod.LAST_7_DAYS) {
                    newDateFrom = buildDateFrom(7)
                } else if (value === TimePeriod.LAST_14_DAYS) {
                    newDateFrom = buildDateFrom(14)
                } else if (value === TimePeriod.LAST_30_DAYS) {
                    newDateFrom = buildDateFrom(30)
                }
                const newDateTo = buildDateTo()
                setDateFrom(newDateFrom)
                setDateTo(newDateTo)
                search(searchText, newDateFrom, newDateTo)
            }
        }
    }

    const searchField: FilterField = {
        name: 'search',
        type: FieldType.TEXT,
        placeholder: 'Buscar por nombre o DNI',
        icon: 'search',
        onChange: handleSearch
    }

    const onChangeDateFrom = (value?: FieldValue) => {
        const newDateFrom = value as O<Date>
        newDateFrom?.setHours(0, 0, 0, 0)
        if (newDateFrom) {
            setPeriod(TimePeriod.MANUAL)
            setDateFrom(newDateFrom)
            search(searchText, newDateFrom, dateTo)
        }
    }
    
    const onChangeDateTo = (value?: FieldValue) => {
        const newDateTo = value as O<Date>
        newDateTo?.setHours(23, 59, 59, 999)
        if (newDateTo) {
            setPeriod(TimePeriod.MANUAL)
            setDateTo(newDateTo)
            search(searchText, dateFrom, newDateTo)
        }
    }

    const filterFields: FilterField[] = [
        {
            name: 'period',
            type: FieldType.SELECT,
            value: period,
            options: timePeriodOptions(),
            label: 'Período Envíos',
            space: 4,
            required: true,
            onChange: onChangePeriod
        },
        {
            name: 'dateFrom',
            type: FieldType.DATE,
            value: dateFrom,
            label: 'Envíos: Desde',
            max: dateTo,
            space: 3,
            onChange: onChangeDateFrom
        },
        {
            name: 'dateTo',
            type: FieldType.DATE,
            value: dateTo,
            label: 'Envíos: Hasta',
            min: dateFrom,
            max: new Date(),
            space: 3,
            onChange: onChangeDateTo
        }
    ]

    return (
        <Filters
            filtersKey={FiltersKey}
            searchField={searchField}
            fields={filterFields}
        />
    )
}
